import { useContext, useEffect, useMemo } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { SPACE_CURATION_REVIEW_SUGGESTIONS_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';

const NAME = SPACE_CURATION_REVIEW_SUGGESTIONS_EXPERIENCE;

export type ReviewSuggestionsExperience = {
	succeed: () => void;
	fail: () => void;
	abortNotProvisioned: () => void;
};

export const useReviewSuggestionsExperience = (): ReviewSuggestionsExperience => {
	const experienceTracker = useContext(ExperienceTrackerContext);

	useEffect(() => {
		experienceTracker.start({ name: NAME });

		return () => {
			const state = experienceTracker.getExperienceState(NAME);
			if (state && !state.hasStopped) {
				experienceTracker.abort({
					name: NAME,
					reason: 'Modal closed before suggestions rendered',
				});
			}
		};
	}, [experienceTracker]);

	return useMemo(
		() => ({
			succeed: () => experienceTracker.succeed({ name: NAME }),
			fail: () =>
				experienceTracker.fail({
					name: NAME,
					error: new Error('Space curation review modal rendered zero suggestions'),
				}),
			abortNotProvisioned: () =>
				experienceTracker.abort({
					name: NAME,
					reason: 'Suggestions endpoint returned 404 (feature not provisioned)',
				}),
		}),
		[experienceTracker],
	);
};
